import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white py-20 px-4" data-id="element-110">
      <div className="max-w-3xl mx-auto border-4 border-[#39FF14] rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-[0_0_20px_rgba(57,255,20,0.15)]" data-id="element-111">
        <div className="absolute top-0 left-0 w-full h-2 bg-[#39FF14]" data-id="element-112"></div>

        <div className="flex justify-center mb-6" data-id="element-113">
          <ShieldCheck className="text-[#39FF14]" size={80} data-id="element-114" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-115">
          Garantía 7 días sin preguntas
        </h2>

        <p className="text-lg text-gray-700 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-116">
          Abrí los 14 Tomos. Revisá los 6 Bonos. Usá los Ebooks Élite en tu
          campo. Si no es lo que esperabas → 100% de devolución. Sin preguntas.
          Sin formularios. Sin drama.
        </p>

        <div className="inline-block bg-green-100 text-green-800 px-6 py-2 rounded-full font-bold text-sm md:text-base uppercase tracking-wide" data-id="element-117">
          TASA DE DEVOLUCIONES MENOR AL 2%
        </div>
      </div>
    </section>;
}